import { NL } from "./ui-nl";
import { NL2 } from "./ui-nl2";
import { NL3 } from "./ui-nl3";
import { NL4 } from "./ui-nl4";
import { NL5 } from "./ui-nl5";
import { NL6 } from "./ui-nl6";
import { NL7 } from "./ui-nl7";
import { NL8 } from "./ui-nl8";
import { FR } from "./ui-fr";
import { FR2 } from "./ui-fr2";
import { FR3 } from "./ui-fr3";
import { FR4 } from "./ui-fr4";
import { FR5 } from "./ui-fr5";
import { FR6 } from "./ui-fr6";
import { FR7 } from "./ui-fr7";
import { FR8 } from "./ui-fr8";
import { FR9 } from "./ui-fr9";
import { DE } from "./ui-de";
import { DE2 } from "./ui-de2";
import { DE3 } from "./ui-de3";
import { DE4 } from "./ui-de4";
import { DE5 } from "./ui-de5";
import { DE6 } from "./ui-de6";
import { DE7 } from "./ui-de7";
import { DE8 } from "./ui-de8";
import { DE9 } from "./ui-de9";

export const UI = {
  nl: { ...NL, ...NL2, ...NL3, ...NL4, ...NL5, ...NL6, ...NL7, ...NL8 },
  fr: { ...FR, ...FR2, ...FR3, ...FR4, ...FR5, ...FR6, ...FR7, ...FR8, ...FR9 },
  de: { ...DE, ...DE2, ...DE3, ...DE4, ...DE5, ...DE6, ...DE7, ...DE8, ...DE9 },
};
